import { DocumentMetadataProxyFragment } from '@/generated/graphql';
import { UploadFile } from 'antd';
import uuid from 'react-uuid';
import { mimeTypeToFileExtension } from '../file/mime-type-to-file-extension';
import { proxy_buildDocumentDownloadUrl } from './document-url-helper';

export const documentToUploadFile = (
  documentMetadataProxy: Nullable<DocumentMetadataProxyFragment>,
): UploadFile<unknown> => {
  const clinicId = documentMetadataProxy?.clinicId;
  const documentMetadata = documentMetadataProxy?.document;

  const documentId = documentMetadata?.documentId;

  const fileName = documentMetadata?.fileName ?? documentId;
  const mimeType = documentMetadata?.mimeType;

  const fileExt = !!mimeType ? mimeTypeToFileExtension(mimeType) : undefined;

  if (!clinicId || !documentId || !mimeType || !fileExt || !fileName) {
    console.error('Required document properties incomplete');
    return {
      uid: uuid(),
      status: 'error',
      fileName: 'Fehler',
      name: 'Fehler',
      url: undefined,
    };
  }

  return {
    uid: documentId,
    status: 'done',
    fileName: fileName,
    type: mimeType,
    name: fileName,
    url: proxy_buildDocumentDownloadUrl(clinicId, documentId, false, false)?.toString(),
  };
};
